import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome"
import React, { FC } from "react"
import { StyleSheet, View } from "react-native"
import styled from "styled-components/native"
import { color, dimensions, palette } from "../../theme"
import { Button } from "../Button/Button"
import { PopUp } from "../PopUp/PopUp"
import { Text } from "../Text/Text"
import { SPACER, TEXT, VIEW } from "./DropdownMenu.presets"
import { DropdownMenuProps } from "./DropdownMenu.props"
import { DropDownOption } from "./DropDownOption"

export const DropdownMenu: FC<DropdownMenuProps> = (props) => {
  const {
    defaultTitle = "None Selected",
    style: styleOverride,
    options,
    onChange,
    value,
    error,
    disabled,
    anchor,
    ...rest
  } = props

  // This allows custom styles to be passed to the component
  const viewStyle = StyleSheet.flatten([
    VIEW,
    {
      backgroundColor: disabled ? color.formElement : palette.white,
    },
    styleOverride,
  ])

  const title = value ? value.title : defaultTitle

  let popUp: PopUp | null = null

  const setPopUpRef = (ref: PopUp) => {
    popUp = ref
  }
  const hidePopUp = () => {
    popUp?.hide()
  }
  const showPopUp = () => {
    popUp?.show()
  }

  const selectElement = (id: number | string, title: string) => {
    onChange?.({ id, title })
    hidePopUp()
  }

  return (
    <StyledPopup
      animationType="fade"
      transparent={true}
      ref={setPopUpRef}
      anchor={
        !!anchor ? (
          anchor({ showPopUp })
        ) : (
          <>
            <Button
              preset="tertiary"
              style={viewStyle}
              disabled={disabled}
              {...rest}
              onPress={showPopUp}
            >
              <Text style={TEXT}>{title}</Text>
              <View style={SPACER} />
              <FontAwesomeIcon icon="chevron-down" />
            </Button>
            {error && <Text preset="error">{error.message}</Text>}
          </>
        )
      }
    >
      {options.map((option, index) => (
        <DropDownOption
          key={option.id}
          first={index === 0}
          title={option.title}
          selectOption={() => selectElement(option.id, option.title)}
          preset={value === option ? "selected" : "default"}
        />
      ))}
    </StyledPopup>
  )
}

const StyledPopup = styled(PopUp)`
  padding: 0px;
  border-radius: ${dimensions.buttonRadius}px;
  border-width: 0;
  elevation: 2;
`
